import MaterialIcon from '@components/common/MaterialIcon';
import DropDownSearchInput from '@components/tailwind-components/Dropdown/DropDownSearchInput';
import type { TemplateResponseDTO } from '@conversed/rest/src/contracts/template-response/template-response.dto';
import type React from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  templates: TemplateResponseDTO[];
  clearTrigger: number;
  onSelect: (name: string, responseId: string) => void;
};

export const ConversationReviewTemplateResponses: React.FC<Props> = ({
  templates,
  clearTrigger,
  onSelect,
}) => {
  const { t } = useTranslation();

  const values = useMemo(
    () =>
      templates.map((template) => ({
        value: template._id.toString(),
        description: template.name,
      })),
    [templates],
  );

  if (values.length === 0) {
    return null;
  }

  return (
    <div className='conversation-review-modal__template-responses'>
      <div className='conversation-review-modal__section-label'>
        <MaterialIcon
          type='outlined'
          icon='style'
          classes={['conversation-review-modal__section-label-icon']}
        />
        <span className='conversation-review-modal__section-label-text'>
          {t('common.template-responses')}
        </span>
      </div>
      <DropDownSearchInput
        name='templateResponse'
        label=''
        values={values}
        setValue={onSelect}
        clearTrigger={clearTrigger}
        isEnabled={true}
        placeholder={t('train-ai.fact-checking.select-template-response')}
        parentClassName='conversation-review-modal__template-responses-dropdown'
        inputClassName='!text-xs py-2'
        dropdownItemClassName='!text-xs'
      />
    </div>
  );
};
